/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/require-default-props */
import React from 'react';
import { styled } from '@mui/material/styles';
import { Bert } from 'meteor/themeteorchef:bert';
import { Box, Button, Container, Modal, Typography, SvgIcon } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import TreeView from '@mui/lab/TreeView';
import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import { isEmpty } from 'lodash';
import useTimeStore from '../ZustandProvider';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import { useStyles } from '../../../styles/mapStylesCustom';

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CircleSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047,22.074l0,-20.147l0,0l-20.12,0l0,0l0,20.147l0,0l20.12,0zm0,1.926l-20.12,0q-0.803,0 -1.365,-0.562t-0.562,-1.365l0,-20.147q0,-0.776 0.562,-1.351t1.365,-0.575l20.147,0q0.776,0 1.351,0.575t0.575,1.351l0,20.147q0,0.803 -0.575,1.365t-1.378,0.562l0,0zm-4.174,0" />
      <ellipse stroke="null" cx="12" cy="12" id="svg_2" rx="4.56349" ry="4.80159" />
    </SvgIcon>
  );
}
function CloseSquare(props) {
  return (
    <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
  color: theme.palette.text.secondary,
  [`& .${treeItemClasses.content}`]: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '&.Mui-expanded': {
      fontWeight: theme.typography.fontWeightRegular
    },
    '&:hover': {
      backgroundColor: '#EEEEEE'
    },
    '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
      color: 'var(--tree-view-color)'
    },
    [`& .${treeItemClasses.label}`]: {
      fontWeight: 'inherit',
      color: 'black'
    }
  },
  [`& .${treeItemClasses.group}`]: {
    marginLeft: 0,
    [`& .${treeItemClasses.content}`]: {
      paddingLeft: theme.spacing(2)
    }
  }
}));

const StyledTreeItem = props => {
  const classes = useStyles();
  const {
    bgColor,
    changeLoading,
    color,
    labelText,
    isModal,
    ID,
    idMap,
    template,
    templates,
    ...other
  } = props;

  const setElemento = useTimeStore(state => state.setElemento);
  const setData = useTimeStore(state => state.setData);
  const setAdjustMap = useTimeStore(state => state.setAdjustMap);

  const [modal, setModal] = React.useState(false);
  const [modalDelete, setModalDelete] = React.useState(false);
  const getModalStyle = () => {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`
    };
  };
  const [modalStyle] = React.useState(getModalStyle);

  const templatesArray = templates.child.findIndex(
    x =>
      x.name === labelText &&
      labelText !== 'baseTemplate' &&
      labelText !== 'baseTemplate1' &&
      labelText !== 'baseTemplate2'
  );

  const handleSelectionClick = () => {
    if (isModal && (labelText !== 'Templates' || labelText !== 'Raíz')) {
      setModal(true);
    }
    setElemento(ID);
  };

  const changePlantilla = async () => {
    setAdjustMap(false);
    changeLoading(800);
    setData(template);
    setModal(false);
    try {
      await methodPromise('maps.updateMapVar', idMap, template);
      Bert.alert('Saved!', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const deletePlantilla = async () => {
    const B = templates;
    const index = templates.child.findIndex(x => x.name === labelText);
    setModalDelete(false);

    B.child.splice(index, 1);
    try {
      await methodPromise('maps.updateMapTemplate', idMap, B);
      Bert.alert('Saved!', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const body = (
    <div style={modalStyle} className={classes.modalPaper}>
      <h3>¿Deseas cambiar de plantilla a {labelText}?</h3>
      <Button
        color="primary"
        onClick={() => {
          changePlantilla();
        }}
      >
        Si
      </Button>
      <Button color="error" onClick={() => setModal(false)}>
        Cancelar
      </Button>
    </div>
  );

  const bodyTemplate = (
    <div style={modalStyle} className={classes.modalPaper}>
      <h3>¿Deseas eliminar la plantilla {labelText}?</h3>
      <Button color="primary" onClick={() => deletePlantilla()}>
        Si
      </Button>
      <Button color="error" onClick={() => setModalDelete(false)}>
        Cancelar
      </Button>
    </div>
  );

  return (
    <>
      <StyledTreeItemRoot
        label={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              p: 0.5,
              pr: 0
            }}
          >
            <Typography
              onClick={handleSelectionClick}
              variant="h6"
              sx={{ fontWeight: 'inherit', flexGrow: 1 }}
            >
              {labelText}
            </Typography>
            {templatesArray !== -1 && (
              <Button
                type="button"
                size="small"
                onClick={() => setModalDelete(true)}
                startIcon={<CloseSquare />}
                sx={{ justifyContent: 'flex-end' }}
              />
            )}
          </Box>
        }
        style={{
          '--tree-view-color': color,
          '--tree-view-bg-color': bgColor
        }}
        {...other}
      />
      <Modal open={modal} onClose={() => setModal(false)}>
        {body}
      </Modal>
      <Modal open={modalDelete} onClose={() => setModalDelete(false)}>
        {bodyTemplate}
      </Modal>
    </>
  );
};
StyledTreeItem.defaultProps = {
  bgColor: '',
  changeLoading: () => {},
  color: '',
  labelText: '',
  isModal: false,
  ID: '',
  idMap: '',
  template: {},
  templates: {}
};

StyledTreeItem.propTypes = {
  bgColor: PropTypes.string,
  changeLoading: PropTypes.func,
  color: PropTypes.string,
  labelText: PropTypes.string,
  isModal: PropTypes.bool,
  ID: PropTypes.string,
  idMap: PropTypes.string,
  template: PropTypes.object,
  templates: PropTypes.object
};

const Arbol = props => {
  const classes = useStyles();
  const { idMap } = props;

  const renderTree = (nodes, isModal) => {
    return (
      <StyledTreeItem
        key={nodes.id}
        nodeId={nodes.id}
        ID={nodes.id}
        idMap={idMap}
        labelText={nodes.name}
        isModal={isModal}
        color="black"
        bgColor="#BDBDBD"
        template={isEmpty(nodes.template) ? {} : nodes.template}
        templates={props.templates}
      >
        {Array.isArray(nodes.child) ? nodes.child.map(node => renderTree(node, isModal)) : null}
      </StyledTreeItem>
    );
  };
  return (
    <>
      <Container display="flex" className={classes.boxTree}>
        <TreeView
          className={classes.rootTree}
          defaultExpanded={['1']}
          defaultCollapseIcon={<MinusSquare />}
          defaultExpandIcon={<PlusSquare />}
          defaultEndIcon={<CircleSquare />}
        >
          {renderTree(props.templates, true)}
        </TreeView>

        <TreeView
          className={classes.rootTree}
          defaultExpanded={['1']}
          defaultCollapseIcon={<MinusSquare />}
          defaultExpandIcon={<PlusSquare />}
          defaultEndIcon={<CircleSquare />}
        >
          {renderTree(props.data, false)}
        </TreeView>
      </Container>
    </>
  );
};

Arbol.defaultProps = {
  data: {},
  idMap: '',
  templates: {}
};

Arbol.propTypes = {
  data: PropTypes.object,
  idMap: PropTypes.string,
  templates: PropTypes.object
};
export default Arbol;
